import type { TFunction } from 'i18next'
import { noticeText } from '@/src/renderer/lib/reminders/reminderNotice'
import type { ScheduledReminder } from '@/src/renderer/lib/reminders/schedule'
import type { ReminderNotice } from '@/src/shared/types/reminders'

/**
 * **Die Beschriftung einer Mitteilung** als Termin für die Zustellung — der Text kommt aus
 * `lib/reminders/reminderNotice.ts` (`noticeText`), den auch die Mobile-App nimmt.
 */
export function noticeOf(entry: ScheduledReminder, projectName: string | null, t: TFunction, locale: string): ReminderNotice {
  return {
    key: entry.key,
    reminderId: entry.reminderId,
    taskId: entry.taskId,
    fireAt: entry.fireAt.getTime(),
    ...noticeText(entry, projectName, t, locale),
  }
}
